import CoverageView from "@/modules/coverage/views/CoverageView.vue"
export default {
    path: "/coverage-base-stations",
    name: "Coverage",
    component: CoverageView,
    meta: {
      requiresAuth: true,
      roles: ["ADMIN", "INSTALLER"],
    },
    beforeEnter: (to, from, next) => {
      return next();
    },
  };
  